function e(t = 0, r, n) {
  const {
    currency: o,
    locale: u
  } = r, c = (n == null ? void 0 : n.maximumFractionDigits) ?? 2, a = c === 0 ? 0 : 2, i = new Intl.NumberFormat(u ?? "en-US", {
    style: "decimal",
    minimumFractionDigits: a,
    maximumFractionDigits: c,
    ...n
  }).format(t);
  return `${m(o)} ${i}`;
}
function m(t = "USD") {
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: t,
      currencyDisplay: "narrowSymbol"
    }).format(1)[0];
  } catch {
    return "$";
  }
}
function y(t, r = 1) {
  return r === 0 ? new Intl.NumberFormat("en-US", {
    style: "percent"
  }).format(0) : new Intl.NumberFormat("en-US", {
    style: "percent"
  }).format(t / r);
}
function l(t) {
  return new Intl.NumberFormat("en-US", {
    style: "percent",
    maximumFractionDigits: 2
  }).format(t / 100);
}
function s(t, r, n) {
  return e(Number(t), {
    currency: r,
    locale: n
  }, {
    compactDisplay: "short",
    notation: "compact"
  });
}
const S = {
  currency: e,
  amountShort: e,
  currencySymbol: m,
  percent: l
};
export {
  S as amountFormats,
  s as formatAmountShort,
  e as formatCurrency,
  l as formatPercent,
  m as getCurrencySymbol,
  y as getPercentage
};
//# sourceMappingURL=number-formatter.js.map
